export interface IVisitTodaySummaryType {
  name: string;
  count: number;
}

export class VisitTodaySummaryType {
  name: string;
  count: number;

  constructor(data: IVisitTodaySummaryType) {
    this.name = data.name;
    this.count = data.count;
  }
}

export interface IVisitTodaySummary {
  hourLabel: string;
  arrivedHour: number;
  visitCount: number;
  types: IVisitTodaySummaryType[];
}

export class VisitTodaySummary {
  hourLabel: string;
  arrivedHour: number;
  visitCount: number;
  types: VisitTodaySummaryType[];

  constructor(data: IVisitTodaySummary) {
    this.hourLabel = data.hourLabel;
    this.arrivedHour = data.arrivedHour;
    this.visitCount = data.visitCount;
    this.types = (data.types ?? []).map(
      item => new VisitTodaySummaryType(item)
    );
  }
}
